const iso = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
const months = (now, count, previous = false) => {
  const startMonth = Math.floor(now.getMonth() / count) * count - (previous ? count : 0)
  return { from: iso(new Date(now.getFullYear(), startMonth, 1)), to: iso(new Date(now.getFullYear(), startMonth + count, 0)) }
}
export const COMMERCIAL_PERIODS = [
  { id: 'mes', label: 'Este mês', range: now => months(now, 1) },
  { id: 'mes_passado', label: 'Mês passado', range: now => months(now, 1, true) },
  { id: 'bimestre', label: 'Este bimestre', range: now => months(now, 2) },
  { id: 'bimestre_anterior', label: 'Bimestre anterior', range: now => months(now, 2, true) },
  { id: 'trimestre', label: 'Este trimestre', range: now => months(now, 3) },
  { id: 'trimestre_passado', label: 'Trimestre passado', range: now => months(now, 3, true) },
  { id: 'semestre', label: 'Este semestre', range: now => months(now, 6) },
  { id: 'semestre_passado', label: 'Semestre passado', range: now => months(now, 6, true) },
  { id: 'ano', label: 'Este ano', range: now => months(now, 12) },
  { id: 'ano_passado', label: 'Ano passado', range: now => months(now, 12, true) },
]
